import type { ReactNode } from 'react';

import { cx } from './cx';

export interface EmptyStateProps {
  title: string;
  /** Say what to do next. "No orders" alone leaves the filter bar unsuspected. */
  description?: string | undefined;
  icon?: ReactNode;
  /** A button, usually "Clear filters" or "Try again". */
  action?: ReactNode;
  /** 'danger' for a failed load, which is not the same thing as nothing found. */
  tone?: 'default' | 'danger' | undefined;
  className?: string | undefined;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  tone = 'default',
  className,
}: EmptyStateProps) {
  return (
    <div className={cx('dc-empty', tone === 'danger' && 'dc-empty--danger', className)}>
      {icon !== undefined && (
        <span className="dc-empty__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <p className="dc-empty__title">{title}</p>
      {description !== undefined && <p className="dc-empty__description">{description}</p>}
      {action !== undefined && <div className="dc-empty__action">{action}</div>}
    </div>
  );
}
